import React from 'react';
import { Link } from 'react-router-dom';
import { FaShieldAlt, FaLock } from 'react-icons/fa';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">About SpinHarvester</h3>
            <p className="text-sm mb-4">
              Your trusted source for comprehensive UK casino reviews and exclusive offers. We help you make informed decisions about online gambling.
            </p>
            
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-primary-400 transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/comparison" className="hover:text-primary-400 transition-colors">Compare Offers</Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-primary-400 transition-colors">About Us</Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-primary-400 transition-colors">FAQ</Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/terms" className="hover:text-primary-400 transition-colors">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="hover:text-primary-400 transition-colors">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/cookie-policy" className="hover:text-primary-400 transition-colors">Cookie Policy</Link>
              </li>
            </ul>
          </div>

          {/* Responsible Gambling */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Responsible Gambling</h3>
            <p className="text-sm mb-4">
              <FaShieldAlt className="inline mr-2" />
              We promote responsible gambling. 18+ only.
            </p>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <img src="/images/footer/gamcare.webp" alt="GamCare" className="w-full h-auto mb-2" loading="lazy" />
                <a href="https://www.gamcare.org.uk/" target="_blank" rel="noopener noreferrer" className="text-xs text-primary-400 hover:text-primary-300 transition-colors block">
                  GamCare
                </a>
              </div>
              <div>
                <img src="/images/footer/gambleaware.webp" alt="BeGambleAware" className="w-full h-auto mb-2" loading="lazy" />
                <a href="https://www.gambleaware.org/" target="_blank" rel="noopener noreferrer" className="text-xs text-primary-400 hover:text-primary-300 transition-colors block">
                  BeGambleAware
                </a>
              </div>
              <div>
                <img src="/images/footer/therapy.webp" alt="Gambling Therapy" className="w-full h-auto mb-2" loading="lazy" />
                <a href="https://gamblingtherapy.org/" target="_blank" rel="noopener noreferrer" className="text-xs text-primary-400 hover:text-primary-300 transition-colors block">
                  Gambling Therapy
                </a>
              </div>
              <div>
                <img src="/images/footer/gamblingcommission.webp" alt="Gambling Commission" className="w-full h-auto mb-2" loading="lazy" />
                <a href="https://www.gamblingcommission.gov.uk/" target="_blank" rel="noopener noreferrer" className="text-xs text-primary-400 hover:text-primary-300 transition-colors block">
                  Gambling Commission
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center text-sm">
          <p className="mb-4 md:mb-0">
            © {currentYear} SpinHarvester.com. All rights reserved.
          </p>
          <div className="flex items-center space-x-2">
            <FaLock className="w-4 h-4" />
            <span>Secure & Licensed</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


